import Introduzione from "../pageComponents/Introduzione"
import IntroduzioneMobile from "../pageComponentsMobile/IntroduzioneMobile"
import Page2Mobile from "../pageComponentsMobile/Capitolo1/Page2Mobile"
import Page3Mobile from "../pageComponentsMobile/Capitolo1/Page3Mobile"
import Page4Mobile from "../pageComponentsMobile/Capitolo1/Page4Mobile"
import Page5Mobile from "../pageComponentsMobile/Capitolo1/Page5Mobile"
import Page6Mobile from "../pageComponentsMobile/Capitolo2/Page6Mobile"
import Page7Mobile from "../pageComponentsMobile/Capitolo2/Page7Mobile"
import Page8Mobile from "../pageComponentsMobile/Capitolo2/Page8Mobile"
import Page9Mobile from "../pageComponentsMobile/Capitolo2/Page9Mobile"
import Page10Mobile from "../pageComponentsMobile/Capitolo3/Page10Mobile"
import Page11Mobile from "../pageComponentsMobile/Capitolo3/Page11Mobile"
import Page12Mobile from "../pageComponentsMobile/Capitolo3/Page12Mobile"
import Page13Mobile from "../pageComponentsMobile/Capitolo3/Page13Mobile"
import Page14Mobile from "../pageComponentsMobile/Capitolo4/Page14Mobile"
import Page15Mobile from "../pageComponentsMobile/Capitolo4/Page15Mobile"
import Page16Mobile from "../pageComponentsMobile/Capitolo4/Page16Mobile"
import Page17Mobile from "../pageComponentsMobile/Capitolo4/Page17Mobile"
import CreditsMobile from "../pageComponentsMobile/CreditsMobile"
import Page2 from "../pageComponents/Capitolo1/Page2"
import Page3 from "../pageComponents/Capitolo1/Page3"
import Page4 from "../pageComponents/Capitolo1/Page4"
import Page5 from "../pageComponents/Capitolo1/Page5"
import Page6 from "../pageComponents/Capitolo2/Page6"
import Page7 from "../pageComponents/Capitolo2/Page7"
import Page8 from "../pageComponents/Capitolo2/Page8"
import Page9 from "../pageComponents/Capitolo2/Page9"
import Page10 from "../pageComponents/Capitolo3/Page10"
import Page11 from "../pageComponents/Capitolo3/Page11"
import Page12 from "../pageComponents/Capitolo3/Page12"
import Page13 from "../pageComponents/Capitolo3/Page13"
import Page14 from "../pageComponents/Capitolo4/Page14"
import Page15 from "../pageComponents/Capitolo4/Page15"
import Page16 from "../pageComponents/Capitolo4/Page16"
import Page17 from "../pageComponents/Capitolo4/Page17"
import Credits from "../pageComponents/Credits"

/**
 * IL CATALOG STABILISCE COME SONO ORGANIZZATE LE PAGINE
 * Le pagine sono disposte come in una griglia, i cui indici di riga e colonna sono numeri interi
 * Attenzione a fare in modo che ogni pagina sia vicina ad esattamente due pagine
 * (una da cui si arriva e una a cui si va)
 *
 * Ad esempio
 *                     x
 *      0     1     2     3     4     5
 *      0  -------
 *         |  1  |                            CAPITOLO 1
 *      1  -------------
 *         |  2  |  3  |                      CAPITOLO 2
 *      2  -------------------------
 *  y            |  4  |  5  |  6  |          CAPITOLO 3
 *      3        -------------------------
 *                           |  7  |  8  |    CAPITOLO 4
 *      4                    -------------
 */

const WHITE_1 = "#FFFFFF"
const WHITE_2 = "#FAFAFA"
const BLUE = "#005BBB"

export const CATALOG = {
  "/": {
    y: 0,
    x: 0,
    Component: Introduzione,
    MobileComponent: IntroduzioneMobile,
    props: {
      backgroundColor: WHITE_2,
      zIndex: 1000,
      color: BLUE,
    },
    mobileProps: {
      backgroundColor: WHITE_2,
      zIndex: 1000,
      color: BLUE,
    }
  },
  "/page-2/": {
    y: 1,
    x: 0,
    Component: Page2,
    MobileComponent: Page2Mobile,
    props: {
      backgroundColor: BLUE,
      zIndex: 950,
      color: WHITE_1
    },
    mobileProps: {
      backgroundColor: WHITE_2,
      zIndex: 950,
      color: BLUE,
    }
  },
  "/page-3/": {
    y: 1,
    x: 1,
    Component: Page3,
    MobileComponent: Page3Mobile,
    props: {
      backgroundColor: WHITE_2,
      color: BLUE,
      zIndex: 900,
    },
    mobileProps: {
      backgroundColor: WHITE_2,
      zIndex: 900,
      color: BLUE,
    }
  },
  "/page-4/": {
    y: 1,
    x: 2,
    Component: Page4,
    MobileComponent: Page4Mobile,
    props: {
      backgroundColor: WHITE_2,
      color: BLUE,
      zIndex: 850,
    },
    mobileProps: {
      backgroundColor: WHITE_2,
      zIndex: 850,
      color: BLUE,
    }
  }
  ,
  "/page-5/": {
    y: 1,
    x: 3,
    Component: Page5,
    MobileComponent: Page5Mobile,
    props: {
      backgroundColor: WHITE_2,
      color: BLUE,
      zIndex: 800,
    },
    mobileProps: {
      backgroundColor: WHITE_2,
      color: BLUE,
      zIndex: 800,
    }
  },
  "/page-6/": {
    y: 2,
    x: 3,
    Component: Page6,
    MobileComponent: Page6Mobile,
    props: {
      backgroundColor: BLUE,
      color: WHITE_1,
      zIndex: 750,
    },
    mobileProps: {
      backgroundColor: WHITE_2,
      color: BLUE,
      zIndex: 750,
    }
  },
  "/page-7/": {
    y: 2,
    x: 4,
    Component: Page7,
    MobileComponent: Page7Mobile,
    props: {
      backgroundColor: WHITE_2,
      color: BLUE,
      zIndex: 700,
    },
    mobileProps: {
      backgroundColor: WHITE_2,
      color: BLUE,
      zIndex: 700,
    }
  },
  "/page-8/": {
    y: 2,
    x: 5,
    Component: Page8,
    MobileComponent: Page8Mobile,
    props: {
      backgroundColor: WHITE_2,
      color: BLUE,
      zIndex: 650,
    },
    mobileProps: {
      backgroundColor: WHITE_2,
      color: BLUE,
      zIndex: 650,
    }
  },
  "/page-9/": {
    y: 2,
    x: 6,
    Component: Page9,
    MobileComponent: Page9Mobile,
    props: {
      backgroundColor: WHITE_2,
      color: BLUE,
      zIndex: 600,
    },
    mobileProps: {
      backgroundColor: WHITE_2,
      color: BLUE,
      zIndex: 600,
    }
  },
  "/page-10/": {
    y: 3,
    x: 6,
    Component: Page10,
    MobileComponent: Page10Mobile,
    props: {
      backgroundColor: BLUE,
      color: WHITE_1,
      zIndex: 550,
    },
    mobileProps: {
      backgroundColor: WHITE_2,
      color: BLUE,
      zIndex: 550,
    }
  },
  "/page-11/": {
    y: 3,
    x: 7,
    Component: Page11,
    MobileComponent: Page11Mobile,
    props: {
      backgroundColor: WHITE_2,
      color: BLUE,
      zIndex: 500,
    },
    mobileProps: {
      backgroundColor: WHITE_2,
      color: BLUE,
      zIndex: 500,
    }
  },
  "/page-12/": {
    y: 3,
    x: 8,
    Component: Page12,
    MobileComponent: Page12Mobile,
    props: {
      backgroundColor: WHITE_2,
      color: BLUE,
      zIndex: 450,
    },
    mobileProps: {
      backgroundColor: WHITE_2,
      color: BLUE,
      zIndex: 450,
    }
  },
  "/page-13/": {
    y: 3,
    x: 9,
    Component: Page13,
    MobileComponent: Page13Mobile,
    props: {
      backgroundColor: WHITE_2,
      color: BLUE,
      zIndex: 400,
    },
    mobileProps: {
      backgroundColor: WHITE_2,
      color: BLUE,
      zIndex: 400,
    }
  },
  "/page-14/": {
    y: 4,
    x: 9,
    Component: Page14,
    MobileComponent: Page14Mobile,
    props: {
      backgroundColor: BLUE,
      color: WHITE_1,
      zIndex: 350,
    },
    mobileProps: {
      backgroundColor: WHITE_2,
      color: BLUE,
      zIndex: 350,
    }
  },
  "/page-15/": {
    y: 4,
    x: 10,
    Component: Page15,
    MobileComponent: Page15Mobile,
    props: {
      backgroundColor: WHITE_2,
      color: BLUE,
      zIndex: 300,
    },
    mobileProps: {
      backgroundColor: WHITE_2,
      color: BLUE,
      zIndex: 300,
    }
  },
  "/page-16/": {
    y: 4,
    x: 11,
    Component: Page16,
    MobileComponent: Page16Mobile,
    props: {
      backgroundColor: WHITE_2,
      color: BLUE,
      zIndex: 250,
    },
    mobileProps: {
      backgroundColor: WHITE_2,
      color: BLUE,
      zIndex: 250,
    }
  },
  "/page-17/": {
    y: 4,
    x: 12,
    Component: Page17,
    MobileComponent: Page17Mobile,
    props: {
      backgroundColor: WHITE_2,
      color: BLUE,
      zIndex: 200,
    },
    mobileProps: {
      backgroundColor: WHITE_2,
      color: BLUE,
      zIndex: 200,
    }
  },
  "/crediti/": {
    y: 5,
    x: 12,
    Component: Credits,
    MobileComponent: CreditsMobile,
    props: {
      backgroundColor: WHITE_2,
      color: BLUE,
      zIndex: 100,
    },
    mobileProps: {
      backgroundColor: WHITE_2,
      color: BLUE,
      zIndex: 100,
    }
  },
}
